export default "__VITE_ASSET__tU8f1J00__"